import { mapActions } from "vuex";
import Vue from "vue";
export default Vue.extend({
    methods: {
        ...mapActions(["openAlertError"]),
    },
});
